import { render, staticRenderFns } from "./CadAlunos.vue?vue&type=template&id=26682df8&"
import script from "./CadAlunos.vue?vue&type=script&lang=js&"
export * from "./CadAlunos.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports